// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__2eGu2","Price":"BuildControls_Price__3afDk","OrderButton":"BuildControls_OrderButton__1U0X7","enable":"BuildControls_enable__1SI_C"};